import { IS_PROD } from "./configurations";

export const CONSTANTS = Object.freeze({
  DYNAMIC_IP: {
    TYPE: {
      INDIVIDUAL: ["DYNAMIC", "PARALLEL", "STATIC", "ACCOUNT_REGULAR"],
      GLOBAL: ["COUNTRY_GOOGLE", "COUNTRY_GLOBAL", "GLOBAL_REGULAR"],
    },
  },
  EURO: "EUR",
});

// Max Integer
export const maxInteger = 2147483647;

export const MVAS = "vas";

export const LAST30 = "LAST 30 DAYS";

export const DEFAULT_TREND_ITEMS = 3;

export const DEFAULT_WATCHLIST_ITEMS = 3;

export const PRODUCTION_MODE = IS_PROD === "true";

export const REALLOCATED_BUDGET =
  "Savings represent the portion of your budget that has been reallocated, effectively preventing waste on invalid traffic identified by Opticks";

export const PLAN_MODE = {
  DEMO: "demo",
  FREE: "free_trial",
  SELFSERVICE: "selfservice",
  MANAGED: "managed",
  APPSUMO: "appsumo",
} as const;

export const SELFSERVICE_PAID_PLANS = {
  LITE: "lite",
  PRO: "pro",
  MAX: "max",
} as const;

export const SELFSERVICE_PLANS = ["free_trial", "lite", "pro", "max"];

export const ALL_PLANS = [
  "demo",
  "free_trial",
  "lite",
  "pro",
  "max",
  "managed",
  "appsumo",
];

export const isIframe = (() => {
  try {
    return typeof window !== "undefined" && window.self !== window.top;
  } catch {
    return true;
  }
})();

export const isDemoUrl =
  typeof window !== "undefined" &&
  window.location.hostname === "demo.optickssecurity.com";

const readDemoFrom = (expected: "app" | "landing", storageKey: string) => {
  if (!isDemoUrl) return false;
  const params = new URLSearchParams(window.location.search);
  if (params.get("from") === expected) {
    sessionStorage.setItem(storageKey, "true");
    params.delete("from");
    const newUrl = params.toString()
      ? `${window.location.pathname}?${params}`
      : window.location.pathname;
    window.history.replaceState({}, "", newUrl);
    return true;
  }
  return sessionStorage.getItem(storageKey) === "true";
};

export const isDemoFromApp: boolean = readDemoFrom("app", "demo-from-app");
export const isDemoFromLanding: boolean = readDemoFrom(
  "landing",
  "demo-from-landing"
);

export const pricesMapper = {
  free_trial: 0.0,
  lite: 50.0,
  pro: 200.0,
  max: 699.0,
};
